<template>
    <div class="row align-items-center justify-content-center" style="min-height: 100vh">
     
        <div class="col-12 col-md-8 col-xl-6">
            <LocaleSelect :vertical="collapsed" />
            <form @submit.prevent="login" id="loginForm">
                <Card>
                    <h5 class="font-weight-bold mb-heading">{{ __('Login') }}</h5>
                
                    <FormInput
                        class="form-input-email"
                        :label="__('Email')"
                        autofocus
                        name="email"
                        type="email"
                        v-model="credentials.email"
                        v-validate="'required|email'"
                    >
                    </FormInput>

                    <FormInput
                        class="form-input-password"
                        :label="__('Password')"
                        name="password"
                        type="password"
                        v-model="credentials.password"
                        v-validate="'required'"
                    />

                    <div class="d-flex justify-content-between">

                        <FormCheckBox
                            :label="__('Remember me')"
                            name="rememberMe"
                            v-model="rememberMe"
                        />

                        <router-link
                            class="card-link"
                            to="/password-reset"
                        >
                            {{ __('Forgot your password?') }}
                        </router-link>

                    </div>
                </Card>

                <div class="card-after">
                    <router-link
                        class="btn btn-secondary btn-sm w-25"
                        to="/register"
                    >
                        {{ __('Register') }}
                    </router-link>

                    <button
                        class="btn btn-primary btn-sm w-25"
                        type="submit"
                    >
                        {{ __('Log in') }}
                    </button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import LocaleSelect from '../../plugins/LocaleSelect'
export default {
  name: 'Login',
  components: { LocaleSelect},
  data () {
    return {
      credentials: {
        email: '',
        password: ''
      },
      rememberMe: false
    }
  },

  methods: {
    login () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          this.$auth.login({
            data: this.credentials,
            rememberMe: this.rememberMe,
            redirect: '/',
            fetchUser: true
          }).catch((response) => {
            this.setErrorsFromResponse(response)
          })
        }
      })
    }
  }
}
</script>

